@if (!disabled) {
  @if (priceType === PriceType.Manual) {
    <app-tooltip-wrapper [right]="true" style="display: inline-block;">
      <span class="uncertain-tier icon icon-question"></span>
      <ng-template #tooltip>Hard-coded value</ng-template>
    </app-tooltip-wrapper>
  } @else if (priceType === PriceType.NoRecentValue) {
    <app-tooltip-wrapper [right]="true" style="display: inline-block;">
      <span class="uncertain-tier icon icon-question"></span>
      <ng-template #tooltip>No recent value, using previous value & tier</ng-template>
    </app-tooltip-wrapper>
  } @else if (priceType === PriceType.WeightedAverage) {
    <app-tooltip-wrapper [right]="true" style="display: inline-block;">
      <span class="uncertain-tier icon icon-question"></span>
      <ng-template #tooltip>No reliable recent value, using weighted average of previous values</ng-template>
    </app-tooltip-wrapper>
  } @else if (priceType === PriceType.LowConfidence) {
    <app-tooltip-wrapper [right]="true" style="display: inline-block;">
      <span class="uncertain-tier icon icon-question"></span>
      <ng-template #tooltip>Low confidence</ng-template>
    </app-tooltip-wrapper>
  } @else if (priceType === PriceType.NewValue) {
    <app-tooltip-wrapper [right]="true" style="display: inline-block;">
      <span class="new-tier icon icon-info"></span>
      <ng-template #tooltip>{{ isUnique ? 'New Unique' : 'New Item' }}</ng-template>
    </app-tooltip-wrapper>
  } @else if (priceType === PriceType.FixedBecauseMissing) {
    <app-tooltip-wrapper [right]="true" style="display: inline-block;">
      <span class="uncertain-tier icon icon-cancel-circle"></span>
      <ng-template #tooltip>Using Fixed (SSF) value because it is missing from economy data</ng-template>
    </app-tooltip-wrapper>
  } @else if (priceType === PriceType.LeagueBecauseMissing) {
    <app-tooltip-wrapper [right]="true" style="display: inline-block;">
      <span class="uncertain-tier icon icon-cancel-circle"></span>
      <ng-template #tooltip>Using League value because it is missing from fixed data</ng-template>
    </app-tooltip-wrapper>
  } @else if (priceType === PriceType.BasedOnReward) {
    <app-tooltip-wrapper [right]="true" style="display: inline-block;">
      <span class="uncertain-tier icon icon-info"></span>
      <ng-template #tooltip>Capped to reward value</ng-template>
    </app-tooltip-wrapper>
  } @else if (priceType === PriceType.Capped) {
    <app-tooltip-wrapper [right]="true" style="display: inline-block;">
      <span class="uncertain-tier icon icon-info"></span>
      <ng-template #tooltip>Capped low-value Divination Card</ng-template>
    </app-tooltip-wrapper>
  }
}
